import { CDN_BASE_URL } from '../constants';

const BASE = CDN_BASE_URL;
const VIDEO_BASE = 'website_videos/';
const url = (path: string) => `${BASE}${encodeURIComponent(path).replace(/%2F/g, '/')}`;
const video = (filename: string) => url(`${VIDEO_BASE}${filename}`);
const media = (filename: string) => url(`${VIDEO_BASE}${filename}`);

export const CDN = {
  hero: {
    warrior: url('hero/Warrior.png'),
    spaceport: url('hero/colossal spaceport.png'),
    drama: url('hero/Drama set in 1950s.png'),
    noir: url('hero/Noir.png'),
    temple: url('hero/Ancient Temple.png'),
  },
  features: {
    prompt: url('features/prompt efficiency video.mp4'),
    memory: url('features/persistent memory.mp4'),
    synthesis: url('features/line-level-synthesis.mp4'),
    cinematography: url('features/cinematography_video.mp4'),
    director: url('features/director_video.mp4'),
  },
  audiences: {
    filmmakers: url('built for everyone/filmmakers.mp4'),
    agencies: url('built for everyone/Agencies and enterprises.mp4'),
    creators: url('built for everyone/creators.mp4'),
  },
  gallery: {
    img1: url('line of script/gallery 1.png'),
    img2: url('line of script/gallery 2.png'),
    img3: url('line of script/gallery 3.png'),
    img4: url('line of script/gallery 4.app.png'),
    agencies: url('agencies.png'),
    animated: url('animated.png'),
  },
  positioning: {
    dinner1: url('positioning/dinner_1.png'),
    diner2: url('positioning/diner_2.png'),
    dinner3: url('positioning/dinner_3.png'),
  },
  filmmakers: {
    ingest: media('Film- INGEST.png'),
    breakdown: media('Film- BREAKDOWN.png'),
    direction: media('Film- DIRECTION.png'),
    assembly: media('Film- ASSEMBLY.png'),
  },
  agencies: {
    agencyFeatures: media('Agency Features.png'),
    crossClientIsolation: media('Cross-Client Isolation.png'),
    multiFormatDelivery: media('Multi-Format Delivery.png'),
    commercialRights: media('Commercial Rights.png'),
  },
  videos: {
    agenciesClientIngest: video('Agencies client ingest.mp4'),
    agenciesStage03: video('Agencies Stage-03.mp4'),
    agenciesStage04: video('Agencies Stage-04.mp4'),
    agencyHeroPortrait: video('Agency hero potrait.mp4'),
    continuity: video('Continuity.mp4'),
    direction: video('Direction.mp4'),
    enterpriseBriefApprovedCut: video('Enterprise brief in approved cut.mp4'),
    enterpriseHeroPortrait: video('Enterprise Hero Potrait.mp4'),
    enterpriseSalesEnablement: video('Enterprise Sales Enablement.mp4'),
    enterpriseTeamUseCase: video('Enterprise Team use case.mp4'),
    filmMakerAlt: video('Film Maker (1).mp4'),
    filmMaker: video('Film Maker.mp4'),
    filmSpecSpot: video('FILM- Spec Spot.mp4'),
    filmCut: video('FILM-Cut.mp4'),
    filmDirection: video('FILM-Direction.mp4'),
    ingestAlt: video('Ingest-1.mp4'),
    ingest: video('Ingest.mp4'),
    override: video('Override.mp4'),
    pitch: video('Pitch.mp4'),
    previs: video('Previs.mp4'),
    sceneBreakdownAlt: video('Scene Breakdown-1.mp4'),
    sceneBreakdown: video('Scene breakdown.mp4'),
    scriptEditor: video('Script Editor.mp4'),
    shortFilm: video('Short Flim.mp4'),
    shotControl: video('Shot control.mp4'),
  },
} as const;
